var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-template',{attrs:{"search-config":_vm.searchConfig,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"has-add":"","current-page":_vm.page},on:{"onSearch":_vm.onSearch,"onAdd":function($event){return _vm.$router.push('./add')},"onChangePage":_vm.handleCurrentChange,"onHandle":_vm.handleEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }